export default "__VITE_ASSET__EkouZjxY__"